import { useSelector } from 'react-redux';

import type { StoreState } from './selector.type';

/** Use StoreSelector. */
export const useStoreSelector = useSelector.withTypes<StoreState>();
